export default {
  'reportStock.ABCAnalysis.navigation.title': 'Relatórios',
  'reportStock.ABCAnalysis.navigation.subtitle': 'Estoque',

  'reportStock.ABCAnalysis.tab.abcAnalysis': 'Curva ABC',

  'reportStock.ABCAnalysis.label.report': 'Selecione o tipo de relatório',
  'reportStock.ABCAnalysis.label.importance': 'Classificação por importância',
  'reportStock.ABCAnalysis.label.download': 'Ver relatório como:',

  'reportStock.ABCAnalysis.radio.part': 'Peça',
  'reportStock.ABCAnalysis.radio.service': 'Serviço',
  'reportStock.ABCAnalysis.radio.customer': 'Cliente',
  'reportStock.ABCAnalysis.radio.quantity': 'Quantidade',
  'reportStock.ABCAnalysis.radio.value': 'Valor',

  'reportStock.ABCAnalysis.actions.viewReport': 'Visualizar relatório',
  'reportStock.ABCAnalysis.actions.generatePDF': 'Gerar relatório em PDF',
  'reportStock.ABCAnalysis.actions.generateRTF': 'Gerar relatório em RTF',
};
